
import request from 'components/Utils/Request';
const { REACT_APP_API_URL } = process.env;
export const ADVOCATECLIENTCASE_LIST_REQUEST =
  'ADVOCATECLIENTCASE_LIST_REQUEST';
export const ADVOCATECLIENTCASE_LIST_SUCCESS =
  'ADVOCATECLIENTCASE_LIST_SUCCESS';
export const ADVOCATECLIENTCASE_LIST_FAILURE =
  'ADVOCATECLIENTCASE_LIST_FAILURE';
export const CASE_REGISTRATION_REQUEST = 'CASE_REGISTRATION_REQUEST';
export const CASE_REGISTRATION_SUCCESS = 'CASE_REGISTRATION_SUCCESS';
export const CASE_REGISTRATION_FAILURE = 'CASE_REGISTRATION_FAILURE';
export const UPDATE_ADVOCATECLIENTCASE_REQUEST =
  'UPDATE_ADVOCATECLIENTCASE_REQUEST';
export const UPDATE_ADVOCATECLIENTCASE_SUCCESS =
  'CASE_REGISTRATION_SUCCESS';
export const UPDATE_ADVOCATECLIENTCASE_FAILURE =
  'UPDATE_ADVOCATECLIENTCASE_SUCCESS';
export const DELETE_ADVOCATECLIENTCASE_REQUEST =
  'DELETE_ADVOCATECLIENTCASE_REQUEST';
export const DELETE_ADVOCATECLIENTCASE_SUCCESS =
  'DELETE_ADVOCATECLIENTCASE_SUCCESS';
export const DELETE_ADVOCATECLIENTCASE_FAILURE =
  'DELETE_ADVOCATECLIENTCASE_FAILURE';

export const GET_ADVOCATECLIENTCASEMASTER_DETAIL__REQUEST = 'GET_ADVOCATECLIENTCASEMASTER_DETAIL__REQUEST';
export const GET_ADVOCATECLIENTCASEMASTER_DETAIL_SUCCESS = 'GET_ADVOCATECLIENTCASEMASTER_DETAIL_SUCCESS';
export const GET_ADVOCATECLIENTCASEMASTER_DETAIL_FAILURE = 'GET_ADVOCATECLIENTCASEMASTER_DETAIL_FAILURE';
export const CLIENT_CASE_DETAIL_LIST_REQUEST = 'CLIENT_CASE_DETAIL_LIST_REQUEST';
export const CLIENT_CASE_DETAIL_LIST_SUCCESS = 'CLIENT_CASE_DETAIL_LIST_SUCCESS';
export const CLIENT_CASE_DETAIL_LIST_FAILURE = 'CLIENT_CASE_DETAIL_LIST_FAILURE';
export const CASE_NEXT_DATE_LIST_REQUEST = 'CASE_NEXT_DATE_LIST_REQUEST';
export const CASE_NEXT_DATE_LIST_SUCCESS = 'CASE_NEXT_DATE_LIST_SUCCESS';
export const CASE_NEXT_DATE_LIST_FAILURE = 'CASE_NEXT_DATE_LIST_FAILURE';

export const advocateClientCaseListRequest = () => ({
  type: ADVOCATECLIENTCASE_LIST_REQUEST
});
export const advocateClientCaseListSuccess = payload => ({
  type: ADVOCATECLIENTCASE_LIST_SUCCESS,
  payload
});
export const advocateClientCaseListFailure = payload => ({
  type: ADVOCATECLIENTCASE_LIST_FAILURE,
  payload
});

export const caseRegistrationRequest = () => ({
  type: CASE_REGISTRATION_REQUEST
});
export const caseRegistrationSuccess = payload => ({
  type: CASE_REGISTRATION_SUCCESS,
  payload
});
export const caseRegistrationFailure = payload => ({
  type: CASE_REGISTRATION_FAILURE,
  payload
});

export const updateAdvocateClientCaseRequest = () => ({
  type: UPDATE_ADVOCATECLIENTCASE_REQUEST
});
export const updateAdvocateClientCaseSuccess = payload => ({
  type: UPDATE_ADVOCATECLIENTCASE_SUCCESS,
  payload
});
export const updateAdvocateClientCaseFailure = payload => ({
  type: UPDATE_ADVOCATECLIENTCASE_FAILURE,
  payload
});

export const deleteAdvocateClientCaseRequest = () => ({
  type: DELETE_ADVOCATECLIENTCASE_REQUEST
});
export const deleteAdvocateClientCaseSuccess = payload => ({
  type: DELETE_ADVOCATECLIENTCASE_SUCCESS,
  payload
});
export const deleteAdvocateClientCaseFailure = payload => ({
  type: DELETE_ADVOCATECLIENTCASE_FAILURE,
  payload
});

export const getAdvocateClientCaseMasterDetailRequest = () => ({
  type: GET_ADVOCATECLIENTCASEMASTER_DETAIL__REQUEST
});
export const getAdvocateClientCaseMasterDetailSuccess = payload => ({
  type: GET_ADVOCATECLIENTCASEMASTER_DETAIL_SUCCESS,
  payload
});
export const getAdvocateClientCaseMasterDetailFailure = payload => ({
  type: GET_ADVOCATECLIENTCASEMASTER_DETAIL_FAILURE,
  payload
});

export const clientCaseDetailListRequest = () => ({
  type: CLIENT_CASE_DETAIL_LIST_REQUEST
});
export const clientCaseDetailListSuccess = payload => ({
  type: CLIENT_CASE_DETAIL_LIST_SUCCESS,
  payload
});
export const clientCaseDetailListFailure = payload => ({
  type: CLIENT_CASE_DETAIL_LIST_FAILURE,
  payload
});

export const caseNextDateListRequest = () => ({
  type: CASE_NEXT_DATE_LIST_REQUEST
});
export const caseNextDateListSuccess = payload => ({
  type: CASE_NEXT_DATE_LIST_SUCCESS,
  payload
});
export const caseNextDateListFailure = payload => ({
  type: CASE_NEXT_DATE_LIST_FAILURE,
  payload
});

export const advocateClientCaseDataAction = payload => {
  return {
    type: 'ADVOCATECLIENTCASEDATA',
    payload
  };
};

export const advocateClientCaseErrorAction = payload => {
  return {
    type: 'ADVOCATECLIENTCASEDETAILSERROR',
    payload
  };
};

export const caseDeletedSuccessAction = payload => {
  return {
    type: 'DELETE_CASE_SUCCESS',
    payload
  };
};

export const resetCaseDeletedAction = payload => {
  return {
    type: 'RESET_CASE_DELETED',
    payload
  };
};

export const advocateClientCaseListAPI = (payload, successData, errorMSg, headers = {}) => {
  return dispatch => {
    dispatch(advocateClientCaseListRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/advocate-client-case-list'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(advocateClientCaseListSuccess(res));
        } else {
          errorMSg(res);
        }
      })
      .catch(err => {
        errorMSg(err?.res);
        dispatch(advocateClientCaseListFailure('Something went wrong'));
        throw err;
      });
  };
};

export const caseRegistrationAPI = (payload, successData, errorMSg, headers = {}) => {
  return dispatch => {
    dispatch(caseRegistrationRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/case-registration'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(caseRegistrationSuccess(res));
        } else {
          errorMSg(res);
        }
      })
      .catch(err => {
        errorMSg(err?.res);
        dispatch(caseRegistrationFailure('Something went wrong'));
        throw err;
      });
  };
};

export const updateAdvocateClientCaseAPI = (payload, successData, errorMSg, headers = {}) => {
  return dispatch => {
    dispatch(updateAdvocateClientCaseRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/update-advocate-client-case'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(updateAdvocateClientCaseSuccess(res));
        } else {
          errorMSg(res);
        }
      })
      .catch(err => {
        errorMSg(err?.res);
        dispatch(updateAdvocateClientCaseFailure('Something went wrong'));
        throw err;
      });
  };
};

export const deleteAdvocateClientCaseAPI = (payload, successData, errorMsg, headers = {}) => {
  return dispatch => {
    dispatch(deleteAdvocateClientCaseRequest());
    return request(
      'DELETE',
      `${REACT_APP_API_URL + '/delete-advocate-client-case'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(deleteAdvocateClientCaseSuccess(res));
        } else {
          errorMsg(res);
        }
      })
      .catch(err => {
        errorMsg(err?.res);
        dispatch(deleteAdvocateClientCaseFailure('Something went wrong'));
        throw err;
      });
  };
};

export const getAdvocateClientCaseMasterDetailAPI = (payload, successData, errorMSg, headers = {}) => {
  return dispatch => {
    dispatch(getAdvocateClientCaseMasterDetailRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/get-advocate-client-case-master-detail'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(getAdvocateClientCaseMasterDetailSuccess(res));
        } else {
          errorMSg(res);
        }
      })
      .catch(err => {
        errorMSg(err?.res);
        dispatch(getAdvocateClientCaseMasterDetailFailure('Something went wrong'));
        throw err;
      });
  };
};

export const clientCaseDetailListAPI = (payload, successData, errorMSg, headers = {}) => {
  return dispatch => {
    dispatch(clientCaseDetailListRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/client-case-detail-list'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(clientCaseDetailListSuccess(res));
        } else {
          errorMSg(res);
        }
      })
      .catch(err => {
        errorMSg(err?.res);
        dispatch(clientCaseDetailListFailure('Something went wrong'));
        throw err;
      });
  };
};

export const caseNextDateListAPI = (payload, successData, errorMSg, headers = {}) => {
  return dispatch => {
    dispatch(caseNextDateListRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/case-next-date-list'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(caseNextDateListSuccess(res));
        } else {
          errorMSg(res);
        }
      })
      .catch(err => {
        errorMSg(err?.res);
        dispatch(caseNextDateListFailure('Something went wrong'));
        throw err;
      });
  };
};
